import { memo } from "react";
import { SpaceBackground } from "@/game/SpaceBackground";
import { useFx } from "@/lib/fx/fxTier";

/**
 * Pano de fundo persistente dos menus.
 *
 * Montado UMA vez como irmão do conteúdo (ver `Menu`), então trocar de
 * view não remonta o canvas nem reseta o campo de estrelas — o céu tem
 * continuidade e a navegação parece uma câmera se movendo pelo mesmo
 * espaço, não telas independentes.
 *
 * Camadas, do fundo para a frente:
 *   1. SpaceBackground (canvas)
 *   2. Véu de gradiente — garante contraste de texto sobre qualquer estrela
 *   3. Vinheta — foca o olho no centro (só medium/high)
 *   4. Aurora — dois blobs em deriva lenta (só high)
 */
export const MenuBackdrop = memo(function MenuBackdrop() {
  const tier = useFx((s) => s.tier);
  const reducedMotion = useFx((s) => s.reducedMotion);

  return (
    <div className="fixed inset-0 z-0 pointer-events-none" aria-hidden="true">
      <SpaceBackground />

      {/* Véu de contraste — o mesmo em todas as telas, por isso vive aqui */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#070a16]/85 via-[#0b1024]/70 to-[#070a16]/90" />

      {tier !== "low" && (
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse 120% 80% at 50% 45%, transparent 35%, rgba(4, 7, 18, 0.55) 100%)",
          }}
        />
      )}

      {/* Aurora: só transform/opacity animados, em camada própria de
          composição. Não força repaint de nada acima. */}
      {tier === "high" && !reducedMotion && (
        <>
          <div className="rk-aurora rk-aurora--a" />
          <div className="rk-aurora rk-aurora--b" />
        </>
      )}

      {/* Grão por cima de tudo — quebra o banding dos gradientes */}
      {tier !== "low" && <div className="rk-grain" />}
    </div>
  );
});
